import styled from 'styled-components'

import { Container as Card } from '../../components/Card/styles'
import bgImage from '../../assets/images/login-bg.jpg'

export const Container = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	background-image: url(${bgImage});
  	background-position: bottom;
	background-size: cover;
	background-repeat: no-repeat;

	@media(max-width: 550px) {
		margin-top: 2vh;
	}
`

export const Content = styled(Card).attrs({
	className: 'no-responsive'
})`
	width: 315px;
	text-align: center;
	margin: 36px 0;

	img {
		width: 150px;
	}

	form {
		display: flex;
		flex-direction: column;

		h1 {
			font-size: 18px;
			margin: 0 8px 0;
			font-weight: 500;
		}

		input {
			width: 100%;
		}

		p {
			padding: 15px;
		}

		button {
			margin: 14px 8px;
		}

		a {
			font-size: 14px;
			opacity: 0.8;

			&:hover {
				opacity: 1;
			}
		}
	}
`

export const LogoContainer = styled.div`
	display: flex;
	justify-content: center;
`
